module.exports = __webpack_public_path__ + "static/media/home-entrance-2.a077705c.png";